// extracted by css-extract-rspack-plugin
export default {"paper":"paper-y8ly83","content":"content-ae0dNp","footer":"footer-GgO2UB","cancelButton":"cancelButton-US_bLg"};